export default {
    SET_CONTRACTOR_DATA: 'setContractorData',
    REMOVE_CONTRACTOR_DATA: 'removeContractorHistoryData',
    ADD_CONTRACTOR_HISTORY_GET_PARAMS: 'addContractorHistoryGetParam',
    REMOVE_CONTRACTOR_HISTORY_GET_PARAM: 'removeContractorHistoryGetParam',
    SELECT_OPERATION: 'selectOperation',
    REMOVE_OPERATION: 'removeOperation',
    SELECT_DOCUMENT: 'selectDocument',
    REMOVE_DOCUMENT: 'removeDocument',
    ADD_SELECTED: 'addSelected',
    REMOVE_SELECTED: 'removeSelected',
}